var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52975 1.88251C3.89977 0.667041 5.66851 -0.0028766 7.49999 9.28515e-06C11.6422 9.28515e-06 15 3.35776 15 7.5C15.0024 9.03293 14.5329 10.5294 13.6552 11.7862L11.625 7.5H13.5C13.5 6.30702 13.1444 5.14111 12.4786 4.15122C11.8128 3.16132 10.867 2.39238 9.76201 1.94262C8.65705 1.49287 7.44311 1.38271 6.27524 1.62623C5.10738 1.86974 4.03862 2.45588 3.2055 3.30976L2.5305 1.88326L2.52975 1.88251ZM12.4702 13.1175C11.1002 14.333 9.33147 15.0029 7.49999 15C3.35775 15 0 11.6422 0 7.5C0 5.90625 0.497249 4.42875 1.34475 3.21376L3.375 7.5H1.5C1.49998 8.69298 1.85559 9.85889 2.52141 10.8488C3.18722 11.8387 4.13302 12.6076 5.23797 13.0574C6.34293 13.5071 7.55687 13.6173 8.72474 13.3738C9.8926 13.1303 10.9614 12.5441 11.7945 11.6902L12.4695 13.1167L12.4702 13.1175ZM8.56049 9.621L6.43949 7.5L4.31774 9.621L3.25725 8.5605L6.43949 5.379L8.56049 7.5L10.6822 5.379L11.7427 6.4395L8.56049 9.621V9.621Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.be4e8324.svg";
export { ForwardRef as ReactComponent };